export const COLORS = {
  primary: "#13294B",
  white: "#FFF",
  black: "#000"
};